import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import { Audit } from '../../components/AuditTrail/Audit';
import { HandleApiError } from '../../components/Notifications/APIErrorHandler';
import { getAuditTrail } from '../../api/admin';
import { Spinner } from '../../components/Utils/Loaders';

export const AuditTrail = ({ medicalRecordNumber, entity, entityId, parentKey, fields }) => {

    const [isLoading, setIsLoading] = useState(false);
    const [audit, setAudit] = useState([]);
    useEffect(() => {
        const fetchData = () => {
            setIsLoading(true);
            getAuditTrail(entity, entityId, parentKey)
                .then(response => {
                    var auditTrails = response.data;
                    console.log(auditTrails)
                    setAudit(auditTrails);
                    setIsLoading(false);
                })
                .catch(error => {
                    HandleApiError(error);
                    setIsLoading(false);
                })
        }

        fetchData();
    }, [entity, entityId]);

    if (isLoading)
        return <Spinner />

    if (fields && fields.length > 0) {
        return (
            <Audit audit={audit} fields={fields} isLoading={isLoading} />
        );
    }
    else {
        return (
            <Audit audit={audit} isLoading={isLoading} medicalRecordNumber={medicalRecordNumber} />
        );
    }
}

AuditTrail.propTypes = {
    entity: PropTypes.string,
    entityId: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]).isRequired,
    parentKey: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    fields: PropTypes.array,
    medicalRecordNumber: PropTypes.string,
};